import Model from './Model'

export default class UserModel extends Model {
  public id: number|undefined

  resource () : string {
    return 'users'
  }
}
